import React from "react";
import { View, StyleSheet, Text } from "react-native";
import Svg, { G, Circle } from "react-native-svg";
import { fontFamily } from "@utils/styles";

const App = ({
  total = 100,
  remaining = 0,
  radius = 40,
  strokeWidth = 10,
  text = "",
}) => {
  const circleCircumference = 2 * Math.PI * radius;
  const percentage = (Math.max(0, remaining) / total) * 100;
  const viewRadius = radius + strokeWidth;
  const strokeDashoffset =
    circleCircumference - (circleCircumference * percentage) / 100;

  return (
    <View>
      <View style={styles.graphWrapper}>
        <Svg
          height={radius * 2}
          width={radius * 2}
          viewBox={`0 0 ${viewRadius * 2} ${viewRadius * 2}`}
        >
          <G rotation={-90} originX={viewRadius} originY={viewRadius}>
            <Circle
              cx="50%"
              cy="50%"
              r={radius}
              stroke="rgba(0, 0, 0, 0.1)"
              fill="transparent"
              strokeWidth={strokeWidth}
            />
            <Circle
              cx="50%"
              cy="50%"
              r={radius}
              stroke="rgba(255, 46, 0, 1)"
              fill="transparent"
              strokeWidth={strokeWidth}
              strokeDasharray={circleCircumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
            />
          </G>
          <View style={styles.textContainer}>
            <Text style={styles.text}>{Math.abs(remaining)}</Text>
            <Text style={styles.text1}>{text}</Text>
          </View>
        </Svg>
      </View>
    </View>
  );
};

export default App;

const styles = StyleSheet.create({
  graphWrapper: {
    overflow: "hidden",
    alignItems: "center",
    justifyContent: "center",
  },
  text: {
    lineHeight: 18,
    fontSize: 16,
    color: "rgba(255, 46, 0, 1)",
    fontFamily: fontFamily.bold,
  },
  text1: {
    lineHeight: 18,
    fontSize: 14,
    color: "rgba(255, 46, 0, 1)",
    marginTop: -3,
  },
  textContainer: {
    marginTop: 11,
    alignItems: "center",
    justifyContent: "center",
  },
});
